
import { PublicationsTopModel } from '../models/PublicationsTopModel.js';
import { PublicationsTopView } from '../views/PublicationsTopView.js';

export class PublicationsTopController {
    constructor() {

        this.model = new PublicationsTopModel();
        this.view = new PublicationsTopView();

        this.model.subscribe(state => this.view.render(state));
    }
}